import constants from '@/app-configs/constants'

export default [
  {
    path: '/cases',
    name: 'cases',
    component: () => import('@/views/cases/Cases.vue'),
    meta: {
      pageTitle: 'DEBTIA_CASES',
      breadcrumb: [
        {
          text: 'DEBTIA_CASES',
          active: true,
        },
      ],
      action: constants.action.permissionDebtCaseView,
      resource: constants.resource.debtCase,
      nav: false,
    },
  },
  {
    path: '/cases',
    name: 'nav-cases',
    component: () => import('@/views/cases/Cases.vue'),
    meta: {
      pageTitle: 'DEBTIA_CASES',
      breadcrumb: [
        {
          text: 'DEBTIA_CASES',
          active: true,
        },
      ],
      action: constants.action.permissionDebtCaseView,
      resource: constants.resource.debtCase,
      nav: true,
    },
  },
  {
    path: '/cases/olddetails/:id',
    name: 'case-old-details',
    component: () => import('@/views/cases/CaseDetails.vue'),
    meta: {
      action: constants.action.permissionDebtCaseView,
      resource: constants.resource.debtCase,
    },
  },
  {
    path: '/cases/details/v2/:id',
    name: 'case-details',
    component: () => import('@/views/cases/details/Main.vue'),
    meta: {
      action: constants.action.permissionDebtCaseView,
      resource: constants.resource.debtCase,
    },
  },
  {
    path: '/cases/view-invoice/:id',
    name: 'cases-view-invoice',
    component: () => import('@/views/cases/details/childcomponents/InvoiceDetails.vue'),
    meta: {
      action: constants.action.permissionDebtCaseView,
      resource: constants.resource.debtCase,
    },
  },
  {
    path: '/cases/newdetailslayout/:id',
    name: 'case-new-details-layout',
    component: () => import('@/views/cases/CustomisableCaseDetails.vue'),
    meta: {
      action: constants.action.permissionDebtCaseView,
      resource: constants.resource.debtCase,
    },
  },
  {
    path: '/case-groups',
    name: 'case-groups',
    component: () => import('@/views/cases/CaseGroups.vue'),
    meta: {
      pageTitle: 'DEBTIA_CASE_GROUPS',
      breadcrumb: [
        {
          text: 'DEBTIA_CASE_GROUPS',
          active: true,
        },
      ],
      action: constants.action.permissionListCaseGroup,
      resource: constants.resource.caseGroups,
      nav: true,
    },
  },
]
